// extracted by mini-css-extract-plugin
export default {"input":"_5BzenTHiwShGQdk1OBPnJ1"};